import { Component, OnInit, AfterContentInit, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService, UtilsService } from '../_services/index';
import { fadeInAnimation } from '../_animations/index';
import { AngularFireFunctions } from 'angularfire2/functions';
import { take } from 'rxjs/operators';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
	animations: [fadeInAnimation]
})
export class DashboardComponent implements OnInit, AfterContentInit {
	@HostBinding('@fadeInAnimation') fadeInAnimation = true;
	@HostBinding('style.display') display = 'block';

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private auth: AuthenticationService,
		private utils: UtilsService,
		private fun: AngularFireFunctions
	) {}
	

	async ngOnInit() {
		console.log('Initializing view');
		const user = await this.auth.user
		.pipe(
			take(1)
		).toPromise();
		if (!user) return false;
		if (!user.primaryPhone) {
			this.router.navigate(['/account', { newuser: true }]);
		}
		this.utils.hideSpinner();
	}

	ngAfterContentInit() {
		console.log('Initialized content');
	}

	public async testFunction() {
		console.log('Calling getTestData function...');
		this.utils.showSpinner();
		const res = await this.fun
			.httpsCallable('testCall')({ testData: 'testing this function' })
			.pipe(
				take(1)
			)
			.toPromise();

		this.utils.hideSpinner();
		
		console.log('Response: ', res);

		// getTestData({stuff: 'random text here', stuffTwo: 'other random text here' }).then(result => {
      	// 	await result;
		// 	console.log('Get test data result: ', result)
  		// }).catch(error => {
    	// 	console.log('Error in callable function: ', error);
  		// });
	}

}
